module.exports = "data:image/webp;base64,UklGRpQAAABXRUJQVlA4IIgAAABQBQCdASoZABkAPpE6mUgloyKhKA1QsBIJZwC06BI2XqIwM9di2x3c1uWolYQyF+Qp9AAA/vQ7LqebKQHr6ZKh5eIGsurvj7a+wX33KNPHQrGqhag6gBD0M5e+v8V6yxdV7KI8ujDB2zQha7fRrWdXbS2mqKI5HA+uYXYxJzA3RULPyK9AuIAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/black_sw.webp
// module id = A+9e
// module chunks = 14